import { rem } from 'lib/units';

export const makeContainer = (maxWidth = 1248, gutter = 12) => (`
    margin: 0 auto;
    max-width: ${maxWidth}px;
    width: 100%;
    padding-left: ${rem(gutter)};
    padding-right: ${rem(gutter)};
`);